import React, { FC, useState, useEffect, useRef, useCallback } from 'react';
import FusionCharts from 'fusioncharts';
import { Utility } from "../../helper/index";
import Charts from 'fusioncharts/fusioncharts.charts';
import FusionTheme from 'fusioncharts/themes/fusioncharts.theme.fusion';
import ReactFC from 'react-fusioncharts';
import LoadingSpinner from '../spinner/loading-spinner';
import constantUrl from '../../settings/constants';
import service from '../../service/api/common';
import SessionWarning from '../reusableComponent/sessionWarning';
import { toPng, toJpeg, toSvg } from 'html-to-image';
import html2canvas from "html2canvas";
import jsPDF from 'jspdf';
import { resize, hideSidebar } from '../../settings/resize';

ReactFC.fcRoot(FusionCharts, Charts, FusionTheme);

interface Props {
  globalData: {
        orgId: number,
        orgName: string,
        divId: number,
        divName: string,
        locationId: number,
        locationName: string,
        buildingId: number,
        batteryId: string,
        buildingName: string,
        batteryName: string,
        vehicleId: string,
        vehicleName: string,
        serialId: string,
        serialName: string
    },
  action: string
  // refresh:number
}

const RemainingLifeChart: FC<Props> = ({ globalData, action }) => {
  // const RemainingLifeChart: FC<Props> = ({ globalData, action,refresh }) => {
  let userInfo: any = Utility.getUserInfo();
  let userId: number = userInfo.userId;
  const [isShowSpinner, setIsShowSpinner] = useState<boolean>(false)
  const [reqBody, setReqBody] = useState({ orgId: 0, batteryId: "", vehicleId: "", divisionId: -1, locationId: -1, buildingId: -1 })
  const [chartData, setChartData] = useState<any>({})
  const [batteryIds, setBatteryIds] = useState<any[]>([])
  const [actualThroughput, setActualThroughput] = useState<any[]>([])
  const [remainingThroughput, setrRmainingThroughput] = useState<any[]>([])
  const [batteryCapacity, setBatteryCapacity] = useState<any[]>([])
  const [selectedBatteryId, setSelectedBatteryId] = useState<string>('')
  const [sort, setSort] = useState<boolean>(false)
  const [disabled, setDisabled] = useState<boolean>(false)
  const [chartHeight, setChartHeight] = useState<any>(window.innerHeight * 0.72);
  const [callChartApi, setCallChartApi] = useState<boolean>(false)
  const [initial, setInitial] = useState<boolean>(true);
  
  const sortBtnRef = useRef<HTMLButtonElement>(null)
  const dimensionRef = useRef<HTMLDivElement>(null)
  const mainRef = useRef<HTMLDivElement>(null)
  const ref = useRef<HTMLDivElement>(null)

  // useEffect(()=>{
  //   if (refresh !== 0)setReqBody({ ...reqBody})
  // },[refresh])

  useEffect(() => {
    var gettoken = userInfo.authToken;
    if (!selectedBatteryId && callChartApi) {
      setIsShowSpinner(true);
      (async () => {
        try {
          const response = await service({
            url: constantUrl.api.remainingLife.remainingLifeReport,
            method: "POST",
            data: reqBody,
            headers: { accept: "*/*", Authorization: "Bearer " + gettoken }
          })
          setIsShowSpinner(false)
          setChartData(response)
          getChartData(response)
          setDisabled(false)
        } catch (error) {
          setIsShowSpinner(false)
        }
      })();
    }
  }, [reqBody, selectedBatteryId])

  const getChartData = (response: any) => {
    let batteryIds: any[] = []
    let actualThroughput: any[] = []
    let remainingThroughput: any[] = []

    response.forEach((item: any, index: any) => {
      batteryIds.push({ label: item.batteryId })
      actualThroughput.push({ value: item.actualThroughput, displayValue: item.actualThroughput })
      remainingThroughput.push({ value: item.remainingThroughput, displayValue: item.remainingThroughput })
      batteryCapacity.push({ value: item.capacity, displayValue: item.capacity})
    })
    setBatteryIds(batteryIds)
    setActualThroughput(actualThroughput)
    setrRmainingThroughput(remainingThroughput)
    setBatteryCapacity(batteryCapacity)
  }

  const dataSource: any = {
    chart: {
      numvisibleplot: "6",
      formatnumberscale: "0",
      legendposition: "Top",
      xAxisNameFontColor: "#4f82b6",
      xAxisNameFontBold: "1",
      yAxisNameFontColor: "#4f82b6",
      decimalSeparator: ".",
      thousandSeparatorPosition: "3",
      yAxisNameFontBold: "1",
      formatnumber: "1",
      showvalues: "0",
      showsum: "1",
      rotateValues: "0",
      baseFont: "Inter",
      baseFontSize: "10",
      thickness: "10",
      animation: "1",
      useRoundEdges: "1",
      plotSpacePercent: "60",
      useplotgradientcolor: "0",
      plotgradientcolor: "#FCF6F5",
      xAxisName: "Batteries (By Battery ID)",
      yaxisname: "Ahrs Throughput",
      // exportEnabled:"1",
      // exportfilename:"Remaining_Life_Report",
      plottooltext:
        "<b>$dataValue</b> visits from $seriesName in $label {br}<b>$percentValue</b> of total visits in the life time",
      theme: "fusion"
    },
    categories: [
      {
        category: batteryIds
      }
    ],
    dataset: [
      {
        seriesname: "Actual Throughput",
        color: "#496EED",
        data: actualThroughput
      },
      {
        seriesname: "Remaining Throughput",
        color: "#DBEC2E",
        data: remainingThroughput
      },
      {
        seriesname: "Battery Capacity",
        color: "#00ff00",
        data: batteryCapacity
      }
    ]
  };

  const chartConfigs: any = {
    type: "scrollstackedbar2d",
    renderAt: "chart-container",
    width: "100%",
    valuefontcolor: "#FFFFFF",
    height: chartHeight,
    dataFormat: "json",
    dataSource: dataSource
  };

  useEffect(() => {
    const handleResize = () => {
      setChartHeight(window.innerHeight * 0.72);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [chartHeight]);

  useEffect(() => {
    // check the page permission
    let permission:any =  localStorage.getItem('permissions')
    if(!permission.includes('remaining_time_W'))window.history.back()  

    setInitial(true);
    resize();
    hideSidebar();
    let data: any = sessionStorage.getItem('globalData');
    data = data && JSON.parse(data);
    setSelectedBatteryId("")
    setCallChartApi(true)
    let org = data?.orgId > -1 ? data?.orgId : userId;
    setReqBody({ ...reqBody, orgId: org, divisionId: data?.divId, locationId: data?.locationId, buildingId: data?.buildingId, batteryId: data?.batteryId, vehicleId: data?.vehicleId })
    setInitial(false);
  }, [])

  useEffect(() => {
    if(initial == false) {
      let org = globalData?.orgId > -1 ? globalData?.orgId : userId;
      setReqBody({ ...reqBody, orgId: org, divisionId: globalData?.divId, locationId: globalData?.locationId, buildingId: globalData?.buildingId, batteryId: globalData?.batteryId, vehicleId: globalData?.vehicleId })
    }
  }, [globalData?.orgId, globalData?.divId, globalData?.locationId, globalData?.buildingId, globalData?.batteryId, globalData?.vehicleId])

  const sortBy = () => {
    if (sort) {
      let data = chartData.sort((a: any, b: any) => (a.remainingThroughput > b.remainingThroughput) ? -1 : 1)
      setSort(false)
      setChartData(data)
      getChartData(data)
      if (sortBtnRef.current && chartData.length > 1) { sortBtnRef.current.style.backgroundColor = '#ffffff' }
    } else {
      let data = chartData.sort((a: any, b: any) => (a.remainingThroughput < b.remainingThroughput) ? -1 : 1)
      setSort(true)
      setChartData(data)
      getChartData(data)
      if (sortBtnRef.current && chartData.length > 1) { sortBtnRef.current.style.backgroundColor = 'rgb(201 198 208 / 46%)' }
    }
  }

  useEffect(() => {
    if (action !== "") {
      onButtonClick(action)
    }
  }, [action])

  const onButtonClick = useCallback((value: string) => {
    if (ref.current === null) return
    setIsShowSpinner(true);
    if (value === 'png') {
      toPng(ref.current, { cacheBust: true, })
        .then((dataUrl) => {
          const link = document.createElement('a')
          link.download = 'Remaining_Life_Report.png'
          link.href = dataUrl
          link.click()
          setIsShowSpinner(false);
        })
        .catch((err) => {
          console.log(err)
          setIsShowSpinner(false);
        })
    } else {
      html2canvas(ref.current)
        .then((canvas) => {
          const imgData = canvas.toDataURL('image/png');
          const link = document.createElement('a')
          link.download = 'my-image-name.png';
          const pdf = new jsPDF();
          pdf.addImage(imgData, 'PNG', 5, 20, 200, 100);
          pdf.save("Remaining_Life_Report.pdf");
          setIsShowSpinner(false);
        })
        .catch((err) => {
          console.log(err)
          setIsShowSpinner(false);
        })
    }
  }, [ref])

  return (
    <>
      <LoadingSpinner isShowSpinner={isShowSpinner}></LoadingSpinner>
      <div id="chart1" className=" charts">
        <div className="ChartPanel pl-0 pr-3">
          <div >
            <div className="row mb-2">
              <div>
                <button disabled={disabled} ref={sortBtnRef} onClick={sortBy} type="button" className="btn btn-light sort-btn ml-3">Sort by Est.Life Remaining</button>
              </div>
            </div>
          </div>
        </div>
        <div className='position-relative' ref={ref}>
          <div ref={mainRef} className="bgWhite">
            <div className="chartTitle p-2 text-center"><label className='ml-auto mr-auto'>Remaining Life Report</label></div>
            <span className="export">
            </span>
            <div ref={dimensionRef}>
              <ReactFC {...chartConfigs} />
            </div>
          </div>
        </div>
      </div>
      <SessionWarning />
    </>
  )
}

export default RemainingLifeChart;